import { render, staticRenderFns } from "./Containers.vue?vue&type=template&id=2c44fd86&scoped=true"
import script from "./Containers.vue?vue&type=script&lang=js"
export * from "./Containers.vue?vue&type=script&lang=js"
import style0 from "./Containers.vue?vue&type=style&index=0&id=2c44fd86&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c44fd86",
  null
  
)

export default component.exports